var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDiamondDsk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "16px",
    viewBox: "0 0 24 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDiamondDsk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESKTOP-CHAT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chatrooms-changes2",
    transform: "translate(-869.000000, -184.000000)",
    fill: "#A5A5A5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21-Copy-3",
    transform: "translate(781.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cam2",
    transform: "translate(0.000000, 0.005262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(71.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PlatinumDiamond",
    transform: "translate(17.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8315161,0.547035573 L23.364549,4.94173645 L11.8469918,15.5354791 L0.303995693,4.95523507 L4.53074388,0.547035573 L18.8315161,0.547035573 Z M16.5459957,5.44803557 L7.23899569,5.44803557 L11.8934387,13.4913399 L16.5459957,5.44803557 Z M6.08499569,5.44803557 L2.32099569,5.44803557 L10.3329957,12.7910356 L6.08499569,5.44803557 Z M21.3359957,5.44803557 L17.7019957,5.44803557 L13.5689957,12.5920356 L21.3359957,5.44803557 Z M7.97099569,1.54703557 L4.95731936,1.54703557 L2.17499569,4.44803557 L5.98199569,4.44803557 L7.97099569,1.54703557 Z M14.7619957,1.54703557 L9.18399569,1.54703557 L7.19399569,4.44803557 L16.6219957,4.44803557 L14.7619957,1.54703557 Z M18.4263495,1.54703557 L15.9499957,1.54703557 L17.8099957,4.44803557 L21.4189957,4.44803557 L18.4263495,1.54703557 Z",
    id: "icDiamondDsk"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDiamondDsk);
export default __webpack_public_path__ + "static/media/icDiamondDsk.3def270829cf7131afecf33e72daadbf.svg";
export { ForwardRef as ReactComponent };